const light = '#fff';
const grey = '#d7dfe1';
const dark = '#000';
const disabledColor = '#ccc';
const backgroundColor = '#fff';

let primaryColor = '#b80e80';//magenta
let primaryColorLight = '#d7dfe1';
//let secondaryColor = '#d3da3d';//vert
let secondaryColor = '#fff';
//let tertiaryColor = '#b80e80';//magenta
let tertiaryColor = '#ccc';
let bodyColor = '#00394a';
let titleColor = primaryColor;
let menuColor = "#333";
let footerColor = 'inherit';
let footerLinkColor = primaryColor;
let footerBackgroundColor = 'transparent';
let textColor='#333';

let bannerBackgroundColor='#b7c820';

export {
  light,
  grey,
  dark,
  disabledColor,
  backgroundColor,
  primaryColor,
  primaryColorLight,
  secondaryColor,
  tertiaryColor,
  bodyColor,
  titleColor,
  menuColor,
  footerColor,
  footerLinkColor,
  footerBackgroundColor,
  textColor,
  bannerBackgroundColor,
};



// WEBPACK FOOTER //
// ./src/helpers/colors.js